import {clsx} from 'clsx';
import React, {memo} from 'react';

import {useSetPanelSelection} from '../../state/interactState/hooks';
import {useKeyInfoQueryContext} from '../MultiRunWorkspace/KeyInfoQueryContext';
import {useSingleRunModeContext} from '../MultiRunWorkspace/SingleRunMode';
import {useWorkspaceRefsContext} from '../Workspace/WorkspaceRefsContext';
import {WorkspaceBanners} from '../WorkspaceBanners/WorkspaceBanners';
import {LoaderProxy} from './../../containers/AppLoader';
import {PanelBankControls} from './headerControls/PanelBankControls';
import {PanelBankInner} from './PanelBankInner';
import {type PanelBankProps} from './types';

export const PanelBankLayout = memo(function PanelBankLayout(
  props: PanelBankProps
) {
  const {entityName, projectName, isProjectReadOnly, isMobileWorkspaceTab} =
    props;
  const {isSingleRun} = useSingleRunModeContext();
  const {panelBankConfigRef} = useWorkspaceRefsContext();

  const {keyInfoQuery} = useKeyInfoQueryContext();
  const setPanelSelection = useSetPanelSelection();

  if (keyInfoQuery.loading || keyInfoQuery.error != null) {
    return <LoaderProxy name="key-info-query-loader" />;
  }
  /**
   * The config provider here is a duplication of the behavior currently in the prop drilling. But the existing drilling doens't go far enough down to toggle run aggregation within the panels. This context avoids extra drilling to support that, and also given the the panelBankConfigWithRefs value is very stable, we can gradually thin out the drilling
   */
  return (
    <div
      className={clsx('panel-bank', {
        'panel-bank-with-runs': !isSingleRun,
      })}
      style={{
        height: isSingleRun ? '100%' : '',
      }}>
      <div style={{backgroundColor: 'white'}}>
        <WorkspaceBanners />
        <PanelBankControls
          entityName={entityName}
          panelBankConfigRef={panelBankConfigRef}
          projectName={projectName}
          isProjectReadOnly={isProjectReadOnly}
          workspaceID={props.workspaceID}
          isMobileWorkspaceTab={isMobileWorkspaceTab}
          isRunSelectorMinimized={props.isRunSelectorMinimized}
          toggleMinimizeRunSelectorWithTracking={
            props.toggleMinimizeRunSelectorWithTracking
          }
        />
      </div>
      <PanelBankInner
        panelBankProps={props}
        setPanelSelection={setPanelSelection}
      />
    </div>
  );
});
